import { Modal } from 'bootstrap';
import DOMPurify from 'dompurify';
import { initializePrintCropEditor } from './printCropEditor';

export function initializeStudentCardCropping(root = document) {
    const section = root.querySelector('#schuelerausweis');
    if (!section || section.dataset.cropInitialized) return;
    section.dataset.cropInitialized = 'true';
    const trigger = section.querySelector('[data-student-card-crop-trigger]');
    const preview = section.querySelector('#student-card-rendered-preview');
    const cartButton = section.querySelector('#student-card-add-to-cart');
    const host = section.querySelector('[data-student-card-crop-host]');
    const error = section.querySelector('[data-student-card-crop-error]');
    const positions = new Map();
    let loading = false;
    let activeModal = null;
    window.getStudentCardPhotoCrop = photoId => positions.get(photoId) || {};
    window.updateStudentCardPhotoCrop = photoId => {
        const url = new URL(preview.dataset.previewUrl, window.location.href);
        url.searchParams.set('photoId', photoId);
        Object.entries(positions.get(photoId) || {}).forEach(([key, value]) => url.searchParams.set(key, String(value)));
        preview.src = url.toString();
        error.hidden = true;
    };
    trigger.addEventListener('click', async () => {
        if (loading || activeModal || cartButton.disabled) return;
        const photoId = cartButton.dataset.selectedPhotoId;
        if (!photoId) return;
        loading = true;
        trigger.disabled = true;
        trigger.setAttribute('aria-busy', 'true');
        trigger.querySelector('.spinner-border').hidden = false;
        error.hidden = true;
        try {
            const url = new URL(trigger.dataset.studentCardCropTrigger, window.location.href);
            url.searchParams.set('photoId', photoId);
            const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
            if (!response.ok || response.redirected) throw new Error('Photo crop unavailable');
            if (cartButton.dataset.selectedPhotoId !== photoId || cartButton.disabled) return;
            host.replaceChildren(DOMPurify.sanitize(await response.text(), { RETURN_DOM_FRAGMENT: true }));
            const modal = host.querySelector('.print-crop-modal');
            const form = modal?.querySelector('[data-print-crop-editor]');
            if (!form) throw new Error('Photo crop editor missing');
            const configuration = JSON.parse(form.dataset.printCropEditor);
            Object.assign(configuration, positions.get(photoId) || {});
            form.dataset.printCropEditor = JSON.stringify(configuration);
            form.removeAttribute('action');
            // A modal inside the gallery's transformed containers can scroll the page on focus.
            document.body.append(modal);
            activeModal = modal;
            const scrollPosition = { left: window.scrollX, top: window.scrollY, behavior: 'instant' };
            const instance = new Modal(modal, { backdrop: 'static', keyboard: true });
            initializePrintCropEditor(modal, null, position => {
                positions.set(photoId, position);
                if (cartButton.dataset.selectedPhotoId === photoId) window.updateStudentCardPhotoCrop(photoId);
                instance.hide();
            });
            modal.addEventListener('hidden.bs.modal', () => {
                instance.dispose(); modal.remove(); activeModal = null; host.replaceChildren(); trigger.focus({ preventScroll: true });
                window.requestAnimationFrame(() => window.scrollTo(scrollPosition));
            }, { once: true });
            instance.show();
        } catch {
            activeModal?.remove(); activeModal = null;
            host.replaceChildren(); error.hidden = false;
        } finally {
            loading = false;
            trigger.disabled = cartButton.dataset.inCart === 'true';
            trigger.removeAttribute('aria-busy');
            trigger.querySelector('.spinner-border').hidden = true;
        }
    });
}
